import {
  Form, Modal, Button, InputNumber,
} from 'antd';
import { ErrorBar } from '@components/error-bar';
import { useState } from 'react';
import InfoTip from '@assets/info-tip.svg';
import PackageSizeImg from '@assets/package_size.svg';
import _ from 'lodash';
import { setGPTDimensionInfo } from '@store';
import { EmailAddress } from '@/constants';
import classes from './PackageSizeModal.module.css';
import {
  fields, MODAL_TIPS, MODAL_TITLE,
} from './const';

export default function ModalForm({
  open, data = {}, setOpen, getReviewData, navigate,
}) {
  const [disabled, setDisabled] = useState(false);
  const [showModalTips, setShowModalTips] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    // 这里要计算 去掉最长边之后，剩下的两个的周长，不能超108
    const { lengthInInch, heightInInch, widthInInch } = values;
    const max = Math.max(lengthInInch, heightInInch, widthInInch);
    const girth = (lengthInInch + heightInInch + widthInInch - max) * 2;
    if (girth > 108) {
      setShowModalTips(true);
      setLoading(false);
      return;
    }
    setShowModalTips(false);
    setGPTDimensionInfo(values);

    // 判断尺寸是否更改 更改需要重新调用review 接口
    const notNeedRequest = _.isEqual(data, values);
    if (notNeedRequest) {
      navigate('../review');
      return;
    }
    try {
      const isSuccess = await getReviewData({ useShippingLabel: true, packInfo: values });
      if (isSuccess) {
        navigate('../review');
        setOpen(false);
        return;
      }
      setShowModalTips(true);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    setDisabled(true);
  };
  const onValuesChange = async () => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setDisabled(true);
      },
      () => {
        setDisabled(false);
      },
    );
  };
  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setDisabled(false);
    setShowModalTips(false);
  };
  return (
    <Modal
      open={open}
      title={MODAL_TITLE}
      width="620px"
      backText="Cancel"
      continueText="Continue"
      continueDisabled={disabled}
      onCancel={handleCancel}
      // destroyOnClose
      footer={false}
      bodyStyle={{
        overflow: 'auto', maxHeight: 600,
      }}
      className="payment_modal"
    >
      <div className={classes.modal_tips}>
        <img src={InfoTip} alt="" />

        <span>{MODAL_TIPS}</span>
      </div>
      {showModalTips && (
        <ErrorBar
          message={(
            <div>
              Sorry, your package exceeds the USPS maximum limit for Seel-generated labels. For assistance with label generation, please contact &nbsp;
              <a href={`mailto:${EmailAddress.Seel}`} style={{ color: '#645AFF' }}>{EmailAddress.Seel}</a>
              .
            </div>
)}
          canClose
          onClose={() => setShowModalTips(false)}
          className={classes.error_bar}
        />
      )}
      <Form
        name="returnMethodModalForm"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className={classes.form}
        onValuesChange={onValuesChange}
        initialValues={data}
      >
        <div className={classes.content}>
          <div className={classes.left_form}>
            {fields.map(({
              value, label, rules,
            }) => (
              <Form.Item
                name={value}
                label={label}
                key={value}
                rules={rules}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            ))}
          </div>
          <div className={classes.right}>
            <img src={PackageSizeImg} alt="" />
            <div>*Parcels may not measure more than 108 inches in length and girth combined.</div>
          </div>
        </div>
        <div
          className={classes.modal_bottom}
        >
          <Button onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            disabled={disabled}
          >
            Continue
          </Button>
        </div>
      </Form>
    </Modal>

  );
}
